import React from "react";
import LeftNav from "../../components/leftNav/LeftNav";
import TopNav from "../../components/topNav/TopNav";

const Dashboard: React.FC = () => {
  return (
    <div className="flex h-screen bg-gray-100">
      <LeftNav />

      <div className="flex flex-1 flex-col">
        <TopNav />

        <main className="flex-1 overflow-y-auto p-6">
          <h2 className="mb-4 text-lg font-semibold text-gray-700">Resumen</h2>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <div className="rounded-xl bg-white p-6 shadow hover:shadow-lg transition">
              <h3 className="text-sm font-medium text-gray-500">
                Ventas del día
              </h3>
              <p className="mt-2 text-2xl font-bold text-blue-600">$1,250</p>
            </div>

            <div className="rounded-xl bg-white p-6 shadow hover:shadow-lg transition">
              <h3 className="text-sm font-medium text-gray-500">
                Nuevos usuarios
              </h3>
              <p className="mt-2 text-2xl font-bold text-green-600">35</p>
            </div>

            <div className="rounded-xl bg-white p-6 shadow hover:shadow-lg transition">
              <h3 className="text-sm font-medium text-gray-500">
                Tickets abiertos
              </h3>
              <p className="mt-2 text-2xl font-bold text-red-600">12</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
